import { take, call, put } from 'redux-saga/effects';
import { tasks as actionTypes } from '$constants/action-types';
import * as actions from '$actions/tasks';
import { alert } from './root';
import axios from 'axios';

const fetchAll = (projectId, params) => axios.get(`/projects/${projectId}/tasks`, { params });
const createReport = (projectId, type, q) => axios.post(`/submissions/reports`, { q: { project_id_eq: projectId, ...q }, report: { type } });

function* watchFetchAll() {
  while(true) {
    const action = yield take(actionTypes.FETCH_ALL);
    yield put(actions.fetchAllRequest());

    const { data } = yield call(fetchAll, action.projectId, action.params);
    const tasks = data.data.map(item => {
      item.project_id = action.projectId;
      return item;
    });

    const hasMore = data.meta.total_count / (25 * action.params.page) >= 1;
    yield put(actions.fetchAllSuccess(tasks, hasMore));
  }
}

function* watchCreateReport() {
  while(true) {
    const action = yield take(actionTypes.CREATE_REPORT);
    const { data } = yield call(createReport, action.projectId, action.fileType, action.filters);
    const alertMessage = `We will send you an e-mail with a link that you can
      download the report in 5 minutes.`;

    yield alert('Report Queued', alertMessage);
  }
}


export const watchers = [
  watchFetchAll,
  watchCreateReport
];



// WEBPACK FOOTER //
// ./src/sagas/tasks.js